import { useEffect, useRef, useState } from 'react'
import Svg, { Defs, RadialGradient, Stop, Ellipse, Path, SvgProps } from 'react-native-svg'

interface Props extends SvgProps {
  value?: boolean
}

const VitalityIcon = (props: Props) => {
  const { width, height, value, ...otherProps } = props
  const [on, setOn] = useState(!!value)
  const timeout = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    function blink(i = 0) {
      if (i > 8) return
      timeout.current = setTimeout(() => {
        setOn(i % 2 === 0)
        blink(i + 1)
      }, 500)
    }

    if (!value) {
      clearTimeout(timeout.current as NodeJS.Timeout)
      setOn(false)
    } else blink()
  }, [value])

  const color = on ? '#92c02a' : '#6f6f6e'
  const lightColor = on ? '#a5d494' : '#868686'

  return (
    <Svg width={width} height={height} viewBox="0 0 153.08 154.11" {...otherProps}>
      <Defs>
        <RadialGradient
          id="Naamloos_verloop_8"
          cx={76.54}
          cy={78.1}
          r={76.54}
          data-name="Naamloos verloop 8"
          fx={76.54}
          fy={78.1}
          gradientTransform="translate(0 -1.57)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0} />
          <Stop offset={0.45} stopColor="#020202" />
          <Stop offset={0.68} stopColor="#0a0a0a" />
          <Stop offset={0.87} stopColor="#171717" />
          <Stop offset={1} stopColor="#262626" />
        </RadialGradient>
      </Defs>
      <Ellipse cx={76.54} cy={77.06} rx={76.54} ry={77.06} fill="url(#Naamloos_verloop_8)" strokeWidth="0" />
      <Path
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={1.45}
        d="M77.43 11.53c-35.17 0-63.68 28.7-63.68 64.11s28.51 64.11 63.68 64.11"
      />
      <Path
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={1.45}
        d="M75.65 139.74c35.17 0 63.68-28.7 63.68-64.11s-28.51-64.1-63.68-64.1"
      />
      <Path
        fill="#b1b1af"
        strokeWidth={0}
        d="M60.05 126.01h3.56v.7h-4.78v-.42l3.6-4.46h-3.47v-.71h4.64v.48l-3.56 4.41ZM74.21 124.24l-.05-.02v.02h-4.7c.12 1.07.88 1.91 2.08 1.91.77 0 1.36-.33 1.61-.86h.89c-.32.96-1.3 1.57-2.53 1.57-1.7 0-2.89-1.3-2.89-2.96s1.19-2.94 2.89-2.94c1.59 0 2.7 1.24 2.71 2.92 0 .12 0 .24-.01.35Zm-4.75-.64h3.93c-.1-1.13-.81-1.91-1.9-1.91-1.17 0-1.91.86-2.03 1.91ZM90.09 124.98c.17.76.76 1.22 1.84 1.22.9 0 1.52-.39 1.52-.99 0-.5-.4-.8-.96-.88l-1.26-.22c-.93-.15-1.65-.56-1.65-1.5 0-1.01.89-1.66 2.23-1.66 1.13 0 2.31.5 2.41 1.78h-.76c-.11-.73-.71-1.11-1.65-1.11-.88 0-1.42.39-1.42.93 0 .42.3.75 1.09.87l1.11.19c.81.13 1.66.48 1.66 1.55s-.97 1.73-2.33 1.73c-1.44 0-2.41-.64-2.59-1.91h.77ZM81.91 120.94h-.26c-1.4 0-2.37.98-2.37 2.56v3.22h.82v-3.19c0-1.16.68-1.82 1.68-1.83 1 0 1.68.67 1.68 1.83v3.19h.82v-3.22c0-1.57-.97-2.56-2.37-2.56Z"
      />
      <Path
        fill="none"
        stroke="#ececec"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M81.46 59.1c3.61 0 6.54-2.99 6.54-6.67s-2.93-6.67-6.54-6.67-6.54 2.99-6.54 6.67 2.93 6.67 6.54 6.67ZM95.75 65.85c-1.81-.51-3.62.62-4.13 2.57-3.22 2.57-7.75 0-10.07-2.26-2.32-2.16-5.13-4.82-9.46-4.82-5.64 0-10.07 2.87-12.38 7.9C58.1 72.73 58 76.22 58 76.63c0 1.95 1.51 3.49 3.32 3.49s3.22-1.64 3.52-3.39c.91-5.54 2.92-8.01 5.74-8.31-.5 11.19-4.03 18.17-9.16 18.17-4.23 0-5.94-4.41-6.04-4.62-.6-1.75-2.62-2.67-4.33-2.05-1.81.62-2.72 2.67-2.01 4.41.1.41 3.32 9.24 12.48 9.24 5.84 0 9.86-3.59 12.38-8.83.7-1.33 2.32-1.44 3.52.92 2.72 5.85 2.82 17.14 2.52 21.04-.1 1.95 1.41 3.7 3.42 3.7s3.32-1.44 3.42-3.18c0-.62 1.01-15.91-3.22-24.53-1.21-2.57-.7-5.03 0-6.78 1.41.51 2.92.92 4.73.92 6.74 0 9.46-4.11 10.07-6.57.3-2.05-.81-3.9-2.62-4.41Z"
      />
      <Path
        d="M102.39 45.06c.29 0 .52.16.52.36v14.51c0 .2-.23.36-.52.36-.29 0-.52-.16-.52-.36V45.42c0-.2.23-.36.52-.36Z"
        fill={lightColor}
        strokeWidth="0px"
      />
      <Path
        d="M94.61 52.46c0-.32.16-.59.36-.59h14.51c.2 0 .36.26.36.59 0 .32-.16.59-.36.59H94.97c-.2 0-.36-.26-.36-.59ZM62.56 45.66c-1.52-.42-3.6-.04-5.19 2.05-1.59-2.09-3.67-2.47-5.19-2.05-2.19.6-3.58 2.71-3.58 5.3 0 1.33.52 2.63 1.3 3.82.77 1.19 1.8 2.29 2.84 3.23 2.07 1.88 4.18 3.14 4.36 3.25.08.05.18.08.28.08s.19-.03.28-.08c.18-.1 2.29-1.37 4.36-3.25 1.04-.94 2.07-2.04 2.84-3.23s1.3-2.49 1.3-3.82c0-2.6-1.39-4.7-3.58-5.3Zm-5.66 3.31c.11.18.3.25.47.25s.36-.08.47-.25c1.13-1.87 2.83-2.7 4.43-2.26 1.67.46 2.78 2.1 2.78 4.25 0 1.03-.4 2.08-1.04 3.09-.64 1.01-1.5 1.98-2.41 2.83-1.71 1.61-3.55 2.83-4.23 3.27-.69-.44-2.53-1.65-4.23-3.27-.91-.86-1.77-1.82-2.41-2.83-.64-1.01-1.04-2.06-1.04-3.09 0-2.15 1.11-3.79 2.78-4.25.29-.08.57-.12.86-.12 1.32 0 2.65.83 3.57 2.37Z"
        fill={lightColor}
        strokeWidth="0px"
      />
    </Svg>
  )
}

export default VitalityIcon
